/* eslint-disable sonarjs/no-duplicate-string */

import React from 'react';
import { ComponentInfo, CardPromotionalCode, ChangeEmail } from '@components';
import { useIsOperator } from '@store';

export const PromotionalCodePlaceholder: React.FC = () => {
	const isOperator = useIsOperator();
	return (
		<>
			<ComponentInfo name="PromotionalCodePlaceholder">
				{isOperator ? <ChangeEmail /> : <CardPromotionalCode />}
			</ComponentInfo>
		</>
	);
};
/* cSpell:enable */
